import styled from "styled-components";

import { ComparisonSide } from "../types";

export const CursorBackground = styled.rect<{ side: ComparisonSide }>`
  fill: ${({ side }) =>
    side === "A"
      ? "var(--mode-text-primary-default)"
      : "var(--mode-text-secondary-default)"};
  cursor: ew-resize;
`;

export const CursorMarker = styled.line`
  stroke: #fff;
  stroke-width: 1px;
  cursor: ew-resize;
`;

export const Background = styled.rect<{
  highlight: boolean;
  side: ComparisonSide;
}>`
  stroke-width: 1px;
  stroke: ${({ highlight, side }) =>
    highlight
      ? side === "A"
        ? "var(--mode-text-primary-default)"
        : "var(--mode-text-secondary-default)"
      : "transparent"};
  cursor: move;
  fill: ${({ side }) =>
    side === "A"
      ? "var(--mode-bg-primary-weakest)"
      : "var(--mode-bg-secondary-weakest)"};
  fill-opacity: 0.6;
`;
